<template>
  <div class="b b-arrow-down" @click="click">
    <h5>{{ title }}</h5>
    <!-- Using v-if will cause app crash on load,
         since the selected count is only available on client side (query string),
         and it'll never be rendered on server side,
         this will cause hydration error,
         refs:
         https://github.com/nuxt/nuxt.js/issues/5800#issuecomment-505044167
         https://github.com/nuxt/nuxt.js/issues/1594 -->
    <div v-show="selectedCountLabel" class="b-arrow-down__badge">{{ selectedCountLabel }}</div>
    <!-- Using v-if in SVG component will cause unexpected behaviour,
         must use v-show -->
    <svg-arrow-down v-show="!selectedCountLabel" class="svg-fill" />
  </div>
</template>

<script>
import SvgArrowDown from '../../assets/svg/arrowDown.svg?inline'

export default {
  components: {
    'svg-arrow-down': SvgArrowDown,
  },
  computed: {
    /** calculate the badge number */
    selectedCount() {
      if (Array.isArray(this.value)) {
        // If selected value is an array,
        // return array length
        return this.value.length
      } else {
        // If selected value is non-empty string,
        // return 1
        return this.value ? 1 : 0
      }
    },

    /** convert the badge number to string */
    selectedCountLabel() {
      // If select count is greater than 0,
      // format it into string
      if (this.selectedCount) {
        return this.selectedCount > 9 ? '9+' : `${this.selectedCount}`
      } else {
        return ''
      }
    },
  },
  methods: {
    /** detect click */
    click() {
      this.$emit('click')
    },
  },
  props: {
    /**
     * title
     */
    title: {
      required: true,
      type: String,
    },
    /**
     * selected value
     */
    value: {
      default: () => [],
      type: [String, Number, Array],
    },
  },
}
</script>

<style lang="postcss" scoped>
.b.b-arrow-down {
  @apply flex flex-row cursor-pointer;
  @apply px-2 shadow-none;

  & h5 {
    @apply text-black align-middle;
  }
  & svg {
    @apply text-grey-900 h-6 ml-1;
  }

  & .b-arrow-down__badge {
    @apply rounded-full w-6 bg-red-500 ml-1;
    @apply text-white-plain text-center leading-6;
    font-family: Arial;
  }
}
</style>
